import { useCallback, useRef } from 'react';

import mixpanel from 'mixpanel-browser';

import { useLastFactFindField } from './useLastFactFindField';

const PROGRESS_BAR_TAPPED_EVENT_NAME = 'tapped_progress_bar_fact_find';

export const useTrackProgressBarTapped = (pathname: string) => {
    const lastFieldRef = useLastFactFindField(pathname);
    const lastTrackedKeyRef = useRef<string | null>(null);

    return useCallback(() => {
        const field = lastFieldRef.current;
        const key = `${field.page}|${field.last_interacted_field ?? ''}`;

        if (key === lastTrackedKeyRef.current) {
            return;
        }

        lastTrackedKeyRef.current = key;
        mixpanel.track(PROGRESS_BAR_TAPPED_EVENT_NAME, field);
    }, [lastFieldRef]);
};
